var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('video',{ref:"player",staticClass:"video-js vjs-city-offer minimalistic",attrs:{"controls":"","playsinline":"","crossorigin":""}},[_c('source',{attrs:{"src":_vm.src,"type":_vm.mime}})])])}
var staticRenderFns = []

export { render, staticRenderFns }